import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c33adfc8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "couplingAdress" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "underline font-bold" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "smallIcon icon-pfeil-hoch" }, null, -1))
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "underline font-bold" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "smallIcon icon-pfeil-runter" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_14 = { key: 1 }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_16 = { class: "inputTitle" }
const _hoisted_17 = { class: "w-1/2 flex" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_20 = { class: "float-right" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "clear-both" }, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import {ref, watchEffect, toRef, reactive, computed, onMounted, onBeforeUnmount} from 'vue';
import GridInputFilter from "@/components/GridInputFilter.vue";
import Select from "@/components/inputs/Select.vue";
import ConfirmationHover from "@/components/popups/ConfirmationHover.vue";
import {CouplingActionType, ErrorLocationType, TableType} from "@/utilities/enums/Enums";
import { BryntumGrid } from "@bryntum/grid-vue-3";
import { Store } from "@bryntum/grid";
import { useGlobalStore } from "@/stores/GlobalStore";
import ErrorHandler from "@/utilities/helpers/ErrorHandler";
import {CoupledSystemService} from "@/utilities/services/entities/CoupledSystemService";
import {LocationService} from "@/utilities/services/entities/LocationService";
import {$t} from "@/utilities/i18n/config";
import NullOrUndefinedHelper from "@/utilities/helpers/NullOrUndefinedHelper";
import {getEffectivePostalCode} from "@/utilities/helpers/PostalCodeHelper";



export default /*#__PURE__*/_defineComponent({
  __name: 'LocationCouplingPopup',
  props: {
  data: Object
},
  setup(__props) {

const props = __props

const globalStore = useGlobalStore();

const locationService = new LocationService();



const coupledSystemService = new CoupledSystemService();

const selectedLocation = toRef(props, 'data');

const showCouplings = ref(false);
const showNewCouplings = ref(false);

const systemList = ref(null);
const selectedSystemId = ref(null);
const selectedForeignLocation = ref(null);
const systemsAvailableLocs = ref({});

let tmpCoupledLocs;

/* --- CONFIRMATION HOVER + COUPLING CALLBACK START --- */
const actionMode = ref(null);
const selectedCoupledLocation = ref(null);

const hoverText = computed(()=>{
  return actionMode.value === CouplingActionType.couple
      ? "Standort koppeln?"
      : "Kopplung entfernen?";
});

// shows and postions hover on CellClick (elementId in components/popups/ConfirmationHover.vue)
const showConfirmationHover = (record, event) => {
  const div = document.getElementById('confirmationHover');

  //position and show OR hide confirmationHover
  if(div !== null && div !== undefined){
    const left  = Math.floor(event.clientX) + 'px';
    const top  = Math.floor(event.clientY) + 'px';

    div.style.left = left;
    div.style.top = top;
    div.hidden = !div.hidden;

    if(!div.hidden){
      selectedCoupledLocation.value = record.data;
    }
  }
};

const acceptCallback = async ()=>{
  if (selectedCoupledLocation.value !== null && selectedCoupledLocation.value !== undefined){

    const loc = selectedLocation.value;
    const toCouple = selectedCoupledLocation.value;

    let resp = null;
    let filteredData = null;

    switch (actionMode.value){
      case CouplingActionType.couple:
        resp = await locationService.postCoupleLocation(loc.id, selectedSystemId.value, toCouple.systemCouplingIdentifier);
        if (resp === null || resp === undefined || resp.statusCode !== 0) {
          ErrorHandler.handleError(resp, ErrorLocationType.popup);
          return;
        }

        // remove from available locs
        systemsAvailableLocs.value[selectedSystemId.value] = systemsAvailableLocs.value[selectedSystemId.value].filter((value)=> value.systemCouplingIdentifier !== toCouple.systemCouplingIdentifier);

        // rename for coupling purposes and to avoid another API call
        toCouple.foreignLocationIdentifier = toCouple.systemCouplingIdentifier;
        delete toCouple.systemCouplingIdentifier;

        // set missing properties if needed
        toCouple["foreignSystemName"] = toCouple["foreignSystemName"] ?? systemList.value.find(sys => sys.id === selectedSystemId.value).name;
        toCouple["coupledSystemId"] = toCouple["coupledSystemId"] ?? selectedSystemId.value;

        // update systemName List for location
        loc.coupledSystemsName.push(toCouple.foreignSystemName);

        // add to coupled Locs
        coupledStore.add(toCouple);

        globalStore.showSuccess($t('global.saved'));

        break;

      case CouplingActionType.decouple:
        resp = await locationService.deleteCoupling(loc.id, toCouple.coupledSystemId, toCouple.foreignLocationIdentifier);
        if (resp === null || resp === undefined || resp.statusCode !== 0) {
          ErrorHandler.handleError(resp, ErrorLocationType.popup);
          return;
        }

        // remove from to coupled Locs
        filteredData = coupledStore.records.filter((value)=> value.data.foreignLocationIdentifier !== toCouple.foreignLocationIdentifier);
        coupledStore.setStoreData(filteredData);

        // rename for coupling purposes and to avoid another API call
        toCouple.systemCouplingIdentifier = toCouple.foreignLocationIdentifier;
        delete toCouple.foreignLocationIdentifier;

        // add to available locs
        systemsAvailableLocs.value[toCouple.coupledSystemId].push(toCouple);

        // update table data if current selected system === system of decoupled loc
        if(toCouple.coupledSystemId === selectedSystemId.value) availableStore.setStoreData(systemsAvailableLocs.value[toCouple.coupledSystemId]);

        // update systemName List for location
        loc.coupledSystemsName = loc.coupledSystemsName.filter(n => n !== toCouple.foreignSystemName);

        globalStore.showSuccess($t('global.saved'));

        break;

      default:
        break;
    }

    selectedLocation.value = loc;
  }
}

const hasCoupledLocationForSystem = ()=>{
  const selectedSystem = systemList.value.find(sys => sys.id === selectedSystemId.value);
  return coupledStore.records.some(cLoc => cLoc.data.foreignSystemName === selectedSystem.name);
};


/* --- CONFIRMATION HOVER + COUPLING CALLBACK END --- */


/* --- GRID CONFIG START --- */


const coupledStore = new Store();
const availableStore = new Store();

const reorderColumnsCoupled = ()=>{
  if(!globalStore.userPreferences.userColumnOrder.some(()=>true)) return;

  const orderedColumns = globalStore.userPreferences.userColumnOrder.filter(oc => oc.tableName === TableType[TableType.coupledLocation]);
  for (const oc of orderedColumns) {
    globalStore.moveColumnToIndex(+oc.attributeValue, oc.attributeName, coupledGrid.value.instance.value.columns);
  }
};

const coupledGrid = ref(null);
const useCoupledGridConfig = {
  headerMenuFeature: false,
  cellMenu: false,
  cellEditFeature: false,
  selectionMode: {
    row: false,
    cell: false
  },
  enableTextSelection: true,
  columns: {
    data: [
      { id: 'foreignSystemName', field: 'foreignSystemName', text: $t('popups.locationCoupling.grid.foreignSystemName') },
      { id: 'name', field: 'name', text: $t('popups.locationCoupling.grid.locationName'), flex: 1 },
      {
        id: "coupleConfirm",
        text: '',
        width: 25,
        type: 'template',
        align: "center",
        hideable: false,
        resizable: false,
        sortable: false,
        filterable: false,
        template: () => {
          return '<div class="gridRowButton"><span class="icon-kopplung"></span></div>';
        },
      },
    ],
    listeners:{
      async add(event:any){
        if(event.records.length === 1 && event.isMove[event.records[0].id]){
          await globalStore.saveUserColumnOrder(TableType[TableType.coupledLocation], event.records[0].id, event.index.toString());
        }
      },
    }
  },
  listeners: {
    cellClick({record, cellSelector, event}) {
      if(cellSelector.columnId === "coupleConfirm" ) {
        actionMode.value = CouplingActionType.decouple;
        showConfirmationHover(record, event);
      }
    },
  },
  store: coupledStore,
};
const coupledGridConfig = reactive(useCoupledGridConfig);

const reorderColumnsAvailable = ()=>{
  if(!globalStore.userPreferences.userColumnOrder.some(()=>true)) return;

  const orderedColumns = globalStore.userPreferences.userColumnOrder.filter(oc => oc.tableName === TableType[TableType.availableCouplingLocation]);
  for (const oc of orderedColumns) {
    globalStore.moveColumnToIndex(+oc.attributeValue, oc.attributeName, availableGrid.value.instance.value.columns);
  }
};

const availableGrid = ref(null);
const useAvailableGridConfig = {
  features: {
    cellEditFeature: false,
    cellMenu : {
      // The Cell menu is created, but starts disabled
      disabled : false,
      items: {
        removeRow: false,
        copy: false,
        cut: false
      },
    },
    headerMenuFeature: false,
  },
  selectionMode: {
    row: false,
    cell: false
  },
  enableTextSelection: true,
  columns: {
    data: [
      { id: 'name', field: 'name', text: $t('popups.locationCoupling.grid.locationName'), flex: 1 },
      { id: 'contactInfo.city', field: 'contactInfo.city', text: $t('popups.locationCoupling.grid.city'), flex: 1 },
      { id: 'contactInfo.postalCode', field: 'contactInfo.postalCode', text: $t('popups.locationCoupling.grid.postalCode'), flex: 1, type: 'template', template: ({record}) => getEffectivePostalCode(record.data.contactInfo) },
      {
        id: 'contactInfo.street',
        field : 'contactInfo.street',
        text : $t('popups.locationCoupling.grid.street'),
        flex: 1,
        renderer: ({ record }:any) => {
          const street = NullOrUndefinedHelper(record.contactInfo?.street) ? "" : record.contactInfo?.street;
          const number = NullOrUndefinedHelper(record.contactInfo?.streetNumber) ? "" : record.contactInfo?.streetNumber;
          return `${street} ${number}`;
        },
      },
      {
        id: "coupleConfirm",
        text : '',
        width : 25,
        type: 'template',
        align: "center",
        hideable: false,
        resizable: false,
        sortable: false,
        filterable: false,
        template: () => {
          if(hasCoupledLocationForSystem()) return "";
          return '<div class="gridRowButton"><span class="icon-kopplung"></span></div>';
        },
      },
    ],
    listeners:{
      async add(event:any){
        if(event.records.length === 1 && event.isMove[event.records[0].id]){
          await globalStore.saveUserColumnOrder(TableType[TableType.availableCouplingLocation], event.records[0].id, event.index.toString());
        }
      },
    }
  },
  listeners: {
    cellClick({record, cellSelector, event}) {
      if(cellSelector.columnId === "coupleConfirm" ) {
        actionMode.value = CouplingActionType.couple;
        showConfirmationHover(record, event);
      }
    },
  },
  store: availableStore,
  autoHeight: true
};
const availableGridConfig = reactive(useAvailableGridConfig);


/* --- GRID CONFIG END --- */


// watch for changes of selectedSystem and load availableLocs dependantly
watchEffect(() => {
  selectedForeignLocation.value = null;
  if (selectedSystemId.value !== null) availableStore.setStoreData(systemsAvailableLocs.value[selectedSystemId.value]);
  else availableStore.setStoreData([]);

  globalStore.gridStore = availableStore;

  return selectedSystemId.value;
});

const setGridData = async ()=>{
  const coupledLocsResp = await  locationService.getCoupledLocations(selectedLocation.value.id);
  if(coupledLocsResp === null || coupledLocsResp === undefined || coupledLocsResp.statusCode !== 0){
    ErrorHandler.handleError(coupledLocsResp, ErrorLocationType.popup);
    tmpCoupledLocs = [];
    return;
  }

  tmpCoupledLocs = coupledLocsResp.locationInfo ?? [];

  const coupledSystemsResp = await coupledSystemService.getCoupledSystems();
  if(coupledSystemsResp === null || coupledSystemsResp === undefined || coupledSystemsResp.statusCode !== 0){
    ErrorHandler.handleError(coupledSystemsResp, ErrorLocationType.popup);
    return;
  }

  systemList.value = coupledSystemsResp.coupledSystemInfo;

  // load all availalbleLocations for every system and store them in 'systemsAvailableLocs' & add more info to coupledLocations
  for (const sys of systemList.value){
    try {
      const locationResponse = await coupledSystemService.getLocationsForForeignSystem(sys.id);
      if(locationResponse === null || locationResponse === undefined || locationResponse.statusCode !== 0){
        ErrorHandler.handleError(locationResponse, ErrorLocationType.popup);
        return;
      }

      systemsAvailableLocs.value[sys.id] = locationResponse.availableLocations;

      // add additional info for grid view to coupled locations
      for(const cl of tmpCoupledLocs){
        if (cl.coupledSystemId !== sys.id) return;

        const locInfo = locationResponse.coupledLocations.find(loc => loc.systemCouplingIdentifier === cl.foreignLocationIdentifier);

        if (locInfo !== undefined){
          cl["name"] = locInfo.name;
          cl["contactInfo"] = locInfo.contactInfo;
          cl["info"] = locInfo.info;
          cl["foreignSystemName"] = sys.name;
        }
      }

      coupledStore.setStoreData(tmpCoupledLocs);
      tmpCoupledLocs = [];
    }
    catch (e) {
      console.log(e);
      systemsAvailableLocs.value[sys.id] = [];
    }
  }

  reorderColumnsCoupled();
  reorderColumnsAvailable();
}

onMounted(async ()=>{
  await setGridData();
});

onBeforeUnmount(async ()=>{
  // re-set contentObject, dont know why but it gets converted to undefined when closing modal...
  //@ts-expect-error
  globalStore.modal.contentObject = selectedLocation.value;
  await globalStore.modal.action();
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(ConfirmationHover, {
      text: _unref(hoverText),
      yesAction: acceptCallback
    }, null, 8, ["text"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h5", null, _toDisplayString(_unref($t)('popups.locationCoupling.adress')), 1),
      _createTextVNode(" " + _toDisplayString(_unref(selectedLocation).name), 1),
      _hoisted_2,
      _createTextVNode(" " + _toDisplayString(_unref(selectedLocation).street) + " " + _toDisplayString(_unref(selectedLocation).streetNumber), 1),
      _hoisted_3,
      _createTextVNode(" " + _toDisplayString(_unref(getEffectivePostalCode)(_unref(selectedLocation))) + " " + _toDisplayString(_unref(selectedLocation).city), 1)
    ]),
    _createElementVNode("div", {
      class: "showCouplingsLink",
      onClick: _cache[0] || (_cache[0] = ($event: any) => {showCouplings.value = !showCouplings.value; showNewCouplings.value = false;})
    }, [
      (showCouplings.value)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(_unref($t)('popups.locationCoupling.hideCoupling')), 1),
            _createTextVNode(),
            _hoisted_6
          ]))
        : (_openBlock(), _createElementBlock("span", _hoisted_7, [
            _createElementVNode("span", _hoisted_8, _toDisplayString(_unref($t)('popups.locationCoupling.showCoupling')), 1),
            _createTextVNode(),
            _hoisted_9
          ]))
    ]),
    _withDirectives(_createElementVNode("div", null, [
      _hoisted_10,
      _createVNode(_unref(BryntumGrid), _mergeProps({
        ref_key: "coupledGrid",
        ref: coupledGrid
      }, coupledGridConfig), null, 16)
    ], 512), [
      [_vShow, showCouplings.value]
    ]),
    _hoisted_11,
    _hoisted_12,
    _hoisted_13,
    (!showNewCouplings.value)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "btn primary",
          onClick: _cache[1] || (_cache[1] = ($event: any) => {showNewCouplings.value = true; showCouplings.value = false;})
        }, " + "))
      : _createCommentVNode("", true),
    (showNewCouplings.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("h4", null, _toDisplayString(_unref($t)('popups.locationCoupling.createNewCoupling')), 1),
          _hoisted_15,
          _createElementVNode("div", _hoisted_16, _toDisplayString(_unref($t)('popups.locationCoupling.sourceSystem')), 1),
          _createElementVNode("div", _hoisted_17, [
            _createVNode(Select, {
              selected: selectedSystemId.value,
              options: systemList.value,
              mode: "single",
              class: "w-full",
              onSelectChanged: _cache[2] || (_cache[2] = (value)=>{selectedSystemId.value = value})
            }, null, 8, ["selected", "options"]),
            _createElementVNode("button", {
              class: "btn ml-4",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (showNewCouplings.value = false))
            }, _toDisplayString(_unref($t)("global.cancel")), 1)
          ]),
          (selectedSystemId.value !== null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _hoisted_19,
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(GridInputFilter, {
                    hideFilterButton: true,
                    gridStore: _unref(availableStore)
                  }, null, 8, ["gridStore"]),
                  _hoisted_21
                ]),
                _hoisted_22,
                _createVNode(_unref(BryntumGrid), _mergeProps({
                  ref_key: "availableGrid",
                  ref: availableGrid
                }, availableGridConfig), null, 16),
                _hoisted_23,
                _createElementVNode("button", {
                  class: "btn",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (showNewCouplings.value = false))
                }, _toDisplayString(_unref($t)("global.cancel")), 1)
              ]))
            : _createCommentVNode("", true),
          _hoisted_24
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})